import { isEmpty } from 'lodash';

const useFilters = (filtersData, optionsData) => {
  const { filters = {} } = filtersData;
  const filterFields = [
    {
      name: 'Title',
      filterName: 'title',
      type: 'string',
      value: filters?.title,
    },
    {
      name: 'Query number',
      filterName: 'queryNumber',
      type: 'string',
      value: filters?.queryNumber,
    },
    {
      name: 'Resolution Status',
      filterName: 'resolutionStatus',
      type: 'dropdown',

      options: !isEmpty(optionsData?.resolutionStatus)
        ? Object.values(optionsData?.resolutionStatus).map((data) => ({
            name: data,
            id: data,
          }))
        : [],
      value: filters?.resolutionStatus,
    },
    {
      name: 'Opened On',
      filterName: 'openDate',
      type: 'date',
      value: filters?.openDate,
    },
    {
      name: 'Closed On',
      filterName: 'closeDate',
      type: 'date',
      value: filters?.closeDate,
    },
  ];

  return { filterFields };
};

export default useFilters;
